import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataApprovalLog: [],
  dataApprovalLogById: [],
  dataHistoryApprovalLog: [],
  dataHistoryApprovalLogById: [],
  keyword: {
    approvalLog: ""
  },
  selectType: [
    { value: "APPROVED", label: "APPROVED" },
    { value: "REJECTED", label: "REJECTED" },
  ],
  loading: false,
  sortConfig: {
    key: "dibuatPada",
    direction: "DESC",
    historyApproval: {
      key: "submissionDate",
      direction: "DESC",
    }
  },
};

export const ApprovalLog = createSlice({
  name: "approval_log",
  initialState,
  reducers: {
    ChangeDataApprovalLog: (state, action) => {
      state.dataApprovalLog = action.payload;
    },
    ChangeDataApprovalLogById: (state, action) => {
      state.dataApprovalLogById = action.payload;
    },
    ChangeDataHistoryApprovalLog: (state, action) => {
      state.dataHistoryApprovalLog = action.payload;
    },
    ChangeDataHistoryApprovalLogById: (state, action) => {
      state.dataHistoryApprovalLogById = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const {
  ChangeDataApprovalLog,
  ChangeDataApprovalLogById,
  ChangeDataHistoryApprovalLog,
  ChangeDataHistoryApprovalLogById,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
} = ApprovalLog.actions;

export default ApprovalLog.reducer;